export default __webpack_public_path__ + "static/Agile-Light-e3464a0d7b5a4d4d22798829464f6b26.ttf";